/**
 * Point the browser at a tenant-specific PWA manifest and apple-touch-icon so
 * "Add to Home Screen" installs the franchise's brand — not the default one.
 * Falls back to the site-wide manifest/icon when no slug is provided.
 */
export function applyTenantManifest(slug, iconUrl) {
  try {
    if (typeof document === "undefined") return;
    const manifestHref = slug
      ? `${process.env.REACT_APP_BACKEND_URL || ""}/api/public/${slug}/manifest.json`
      : "/manifest.json";
    let m = document.querySelector('link[rel="manifest"]');
    if (!m) {
      m = document.createElement("link");
      m.setAttribute("rel", "manifest");
      document.head.appendChild(m);
    }
    m.setAttribute("href", manifestHref);

    const appleHref = iconUrl || "/icons/apple-touch-icon.png";
    let a = document.querySelector('link[rel="apple-touch-icon"]');
    if (!a) {
      a = document.createElement("link");
      a.setAttribute("rel", "apple-touch-icon");
      document.head.appendChild(a);
    }
    a.setAttribute("href", appleHref);
  } catch (e) {
    // Alguns webviews Android bloqueiam ou retornam null em
    // `document.querySelector` por CSP/sandbox. Não é crítico pro app,
    // só pro ícone de instalação — nunca pode quebrar a renderização.
    // eslint-disable-next-line no-console
    try { console.warn("[pwa] applyTenantManifest failed:", e); } catch (_) {}
  }
}
